const SegnalazioneSystemInformationsLabels : {[key: string]: string} = {
    state: "Stato",
    type: "Tipo segnalazione",
    dataInvio: "Data invio",
    autoritaEstera: "Soggetto Segnalante",
    codiceProtocollo: "Codice protocollo",
    dataAccettazione: "Data accettazione segnalazione",
    utenteAccettazione: "Utente accettazione segnalazione"
}

export default SegnalazioneSystemInformationsLabels
